import React from "react";
import { Box, Typography, Container, Grid } from "@mui/material";
import Diversity3Icon from '@mui/icons-material/Diversity3';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import EuroIcon from '@mui/icons-material/Euro';

function Home() {
  return (
    <Box>
      {/* Móduclo Banner */}
      <Box sx={{ width: "100%", height: "45vh", overflow: "hidden" }}>
        <img src="/images/banner1.png" alt="BisbalGat Banner" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </Box>


      <Container maxWidth="lg" sx={{ paddingLeft: "100px", py: 4 }}>
        {/* Módulo Informaciones */}
        <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: "bold", color: '#383838' }}>
          BisbalGat ayuda a los gatos
        </Typography>
        <Typography variant="body1" align="center" gutterBottom sx={{ fontSize: '14px' }}>
        La Asociación BisbalGat es una asociación sin ánimo de lucro formada por VOLUNTARIAS con el principal objetivo de ayudar a los gatos necesitados a tener una vida digna. Agradecemos mucho a los adoptantes y también a las personas que se ofrecen para ser casa de acogida, y cómo no, agradecemos muchísimo las donaciones que, por pequeñas que sean, siempre son de gran ayuda.
        </Typography>
      </Container>


      {/* Módulo de ayuda*/}
      <Box sx={{ backgroundColor: "#EDEDED", py: 3}}>
        <Container maxWidth="lg">
          <Typography variant="h6" align="center" sx={{ mt: 4, mb: 2, fontFamily: "Bitter, serif", fontWeight: "bold", color: "#383838" }}>
            ¿Cómo ayudar?
          </Typography>
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: "flex", alignItems: "center", justifyContent: "Center", color: '#383838'}}> <Diversity3Icon sx={{ marginRight: "8px", fontSize: "30px", color: "#B3A6D2", }}/> Teamer</Typography>
                <Typography variant="body2" >Únete a nuestro "teamer" donando 1 euro al mes <br/><a href="https://www.teaming.net/associaciobisbalgat-grupo?lang=es_ES" target="_blank" rel="noopener noreferrer">Enlace de nuestro teamer</a></Typography>
                </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: "flex", alignItems: "center", justifyContent: "Center", color: '#383838'}}> <VolunteerActivismIcon sx={{ marginRight: "8px", fontSize: "30px", color: "#B3A6D2", }}/>Donación</Typography>
                <Typography variant="body2" sx={{ fontFamily: "Bitter, serif" }}>Dona a través de nuestra cuenta bancaria o Bizum: <br/>ES34 0182 0199 9702 0180 4428 o 618 29 36 61 </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: "flex", alignItems: "center", justifyContent: "Center", color: '#383838'}}><EuroIcon sx={{ marginRight: "8px", fontSize: "30px", color: "#B3A6D2", }}/>PayPal</Typography>
                <Typography variant="body2" >Dona lo que quieras usando Paypal <br/><a href="https://www.paypal.me/Bisbalgat?locale.x=es_ES" target="_blank" rel="noopener noreferrer">Haz clic aquí</a></Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <br/>
      <br/>
    </Box>
  );
}

export default Home;
